import { ADD_COURSE, UPDATE_COURSE, SET_COURSE, DELETE_COURSE, SET_PRE_COLLEGE_COURSES,SET_CERT_COURSES } from "../constants";

const initialState = [];

export const courseReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_COURSE: {
            state = [...payload];
            return state;
        }
        case SET_PRE_COLLEGE_COURSES: {
            state = [...payload];
            return state;
        }
        case ADD_COURSE: {
            state = [{ ...payload, course_count: [] }, ...state];
            return state;
        }
        case UPDATE_COURSE: {
            let temp = [...state];
            let index = temp.findIndex(course => course._id === payload.course_id);
            if (index > -1) {
                temp[index][payload.name] = payload.value;
            }
            return temp;
        }
        case DELETE_COURSE: {
            let temp = [...state];
            let index = temp.findIndex(course => course._id === payload);
            if (index > -1) {
                temp.splice(index, 1);
            }
            return temp;
        }
        case SET_CERT_COURSES:{
            state = [...payload];
            return state;
        }
        default: {
            return state
        }
    }
};